import styled, { css } from 'styled-components';
import { TableVariant } from '../types';
export const HeaderCell = styled.th `
  display: flex;
  align-items: center;
  padding: 8px 16px 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  color: ${({ theme }) => theme.secondary.blendToBackground(700)};
  align-items: center;
  justify-content: flex-start;

  ${({ $hasAction, $variant }) => $hasAction &&
    $variant === TableVariant.Grid &&
    css `
      &:not(:nth-last-child(-n + 2)) {
        border-right: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      }
    `}

  ${({ $hasAction, $variant }) => !$hasAction &&
    $variant === TableVariant.Grid &&
    css `
      &:not(:last-child) {
        border-right: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      }
    `}

  ${({ $isStickyLeft, $stickyLeft, $variant }) => $isStickyLeft &&
    css `
      position: sticky;
      left: ${$stickyLeft}px;
      z-index: 2;
      background-color: ${({ theme }) => $variant === TableVariant.List ? theme.background : theme.secondary.blendToBackground(25)};

      ${$variant === TableVariant.List &&
        css `
        &:after {
          content: '';
          position: absolute;
          right: -12px;
          top: 0;
          bottom: 0;
          width: 12px;
          pointer-events: none;
          background: linear-gradient(to right, ${({ theme }) => theme.background} 0px, transparent 12px);
        }
      `}
    `}

  ${({ $isStickyRight, $stickyRight, $variant }) => $isStickyRight &&
    css `
      position: sticky;
      right: ${$stickyRight}px;
      z-index: 2;
      border-left: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      border-right: 0;
      background-color: ${({ theme }) => $variant === TableVariant.List ? theme.background : theme.secondary.blendToBackground(25)};

      &:not(:nth-last-child(-n + 2)) {
        border-right: 1px solid ${({ theme }) => theme.secondary.blendToBackground(200)};
      }

      ${$variant === TableVariant.List &&
        css `
        border-left: none;

        &:before {
          content: '';
          position: absolute;
          left: -12px;
          top: 0;
          bottom: 0;
          width: 12px;
          pointer-events: none;
          background: linear-gradient(to left, ${({ theme }) => theme.background} 0px, transparent 12px);
        }
      `}
    `}

  ${({ $variant }) => $variant === TableVariant.List &&
    css `
      min-height: 24px;
      background-color: ${({ theme }) => theme.background};
    `}
`;
//# sourceMappingURL=HeaderCell.js.map